import { combineReducers } from 'redux';
import collaboratorModule from './collaborator';

export default combineReducers({
    collaboratorModule,
});
